// Footer "Chat met de Lama" link. Tries to open the Shopify Inbox chat bubble
// (shopify-chat custom element, button.activator inside its shadow root); falls
// back to the normal <a href> navigation to the contact page when the bubble
// is not present on the page.
document.addEventListener('click', (event) => {
  const link = event.target.closest('.js-footer-chat-link');
  if (!link) return;

  const activator = document
    .querySelector('shopify-chat')
    ?.shadowRoot?.querySelector('button.activator');

  if (activator) {
    event.preventDefault();
    activator.click();
  }
  // No activator found: let the default navigation to the href happen.
});
